

















































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import { fetchMS } from '@/pantallas/Conecta/Equipos/fetchMS';
import Confirmation from '@/components/Confirmation.vue';

@Component({ components: { DatePicker, Confirmation } })
export default class EquiposEditar extends Vue {
  @Prop({ required: true, default: {} }) data!: any;
  @Prop({ required: true, default: false }) statusFinished!: boolean;
  Activaciones_equipos: any = {};
  dialog: boolean = true;
  tabs: number = 0;
  DROPDOWNS_SERIEACTIVA: any = [];
  paramApi: any = {
    tipoeqid: '',
    equipo: {
      tipoeqid: '',
      tipoeqname: '',
    },
    serieimei: '',
    seriecant_activa: '',
    seriebateria_fecha: '',
    tipoubicaid: '',
    costounitario: '',
    costounitario_clp: '',
    costoflete_oc: '',
    nuevoprecio_unitario: '',
    factorimportacion: '',
    nuevoprecio_unitariousd: '',
    serienumero: '',
    desinstalado: false,
  };
  filterApi: any = {};
  dialogConfirmation: boolean = false;
  confrmationData: {
    title?: string;
    msg?: string;
    action?: 'create' | 'edit' | 'close';
    btnAceptar?: string;
    btnCancelar?: string;
  } = {};
  readonly loadingService = new LoadingService();
  readonly $snotify: Snotify = null;
  loading: boolean = true;
  isEdit: boolean = false;
  accion: string = 'Crear';
  btnDisabled: boolean = false;

  async mounted() {
    try {
      await Promise.all([
        this.getFilters(),
        this.initialValues(),
        this.getEquiposActivacion(),
      ]);
      this.getDropdowns();
    } finally {
      this.loading = false;
    }
  }

  initialValues() {
    // Validar si data trae datos, si lo hace significa que estamos editando datos
    if (Object.keys(this.data).length > 0) {
      this.paramApi = { ...this.data };
      this.paramApi.equipo = {
        tipoeqid: this.data.tipoeqid || '',
        tipoeqname: this.data.tipoeqname || '',
      };
      this.paramApi.desinstalado =
        this.data.desinstalado === 't' ? true : false;
      this.paramApi.seriebateria_fecha = this.data.seriebateria_fecha
        ? moment(this.data.seriebateria_fecha)
        : '';
      this.isEdit = true;
      this.accion = 'Editar';
    }
    this.paramApi.user = localStorage.getItem('clienteDefecto') || '';
    this.paramApi.user_id = JSON.parse(localStorage.getItem('user')).id || '';
  }

  rules = {
    equipo: (value: any) => {
      if (!value || !value.tipoeqid) {
        return 'El equipo es obligatorio';
      }
      return true;
    },
    serienumero: (value: string) => {
      if (!value) {
        return 'La Serie es obligatoria';
      }
      if (value.length > 50) {
        return 'Solo se permite un máximo de 50 caracteres';
      }
      return true;
    },
    serieimei: (value: string) => {
      if (value && value.length > 50) {
        return 'Solo se permite un máximo de 50 caracteres';
      }
      return true;
    },
    seriecant_activa: (value: string) => {
      const seriecant_activa = Number(value);
      if (seriecant_activa > 999999) {
        return 'El número máximo permitido es 999999';
      }
      return true;
    },
    tipoubicaid: (value: string) => {
      if (!value) {
        return 'La ubicación es obligatoria';
      }
      return true;
    },
    costounitario: (value: string) => {
      if (value.includes('.')) {
        const [integerPart, decimalPart] = value.split('.');
        if (decimalPart.length > 2) {
          return 'Solo se permite un máximo de 2 números decimales';
        }
        if (integerPart.length > 13) {
          return 'El número máximo permitido es 9999999999999.99';
        }
      } else if (value && value.length > 15) {
        'El número máximo permitido es 9999999999999.99';
      }
      return true;
    },

    factorimportacion: (value: string) => {
      if (value.includes('.')) {
        const [integerPart, decimalPart] = value.split('.');
        const decimalPartClean = (decimalPart || '')
          .replace(/\s+/g, '')
          .replace('%', '');
        if (decimalPartClean.length > 2) {
          return 'Solo se permite un máximo de 2 números decimales';
        }
        if (integerPart.length > 13) {
          return 'El porcentaje máximo permitido es 9999999999999.99 %';
        }
      } else if (value && value.length > 15) {
        return 'El porcentaje máximo permitido es 9999999999999.99 %';
      }
      return true;
    },
  };

  async handleCost() {
    this.paramApi.costounitario = await this.validateCost(
      this.paramApi.costounitario
    );
    this.paramApi.costounitario_clp = await this.validateCost(
      this.paramApi.costounitario_clp
    );
    this.paramApi.costoflete_oc = await this.validateCost(
      this.paramApi.costoflete_oc
    );
    this.paramApi.nuevoprecio_unitario = await this.validateCost(
      this.paramApi.nuevoprecio_unitario
    );
    this.paramApi.nuevoprecio_unitariousd = await this.validateCost(
      this.paramApi.nuevoprecio_unitariousd
    );
  }

  handlePercent() {
    this.paramApi.factorimportacion = this.validatePercent(
      this.paramApi.factorimportacion
    );
  }

  validatePercent(percent: string) {
    let percentClean = (percent || '').replace(/\s+/g, '').replace('%', '');
    // Validamos si hay datos
    if (!percentClean) return '';

    if (percentClean.length === 15) {
      // Poner los dos últimos como decimal
      percentClean = percentClean.slice(0, 13) + '.' + percentClean.slice(13);
    } else if (percentClean.length <= 13) {
      // Agregar '00' al final con el punto
      percentClean += percentClean.includes('.') ? '00' : '.00';
    } else if (percentClean.length === 14) {
      // Convertir el ultimo número en decimal y agregarle un cero
      percentClean =
        percentClean.slice(0, 13) + '.' + percentClean.slice(13) + '0';
    }

    // Validar si existen números decimales en la cadena de texto
    if (percentClean.includes('.')) {
      // Dividir la cadena en parte entera y parte decimal
      const [integerPart, decimalPart] = percentClean.split('.');

      // Verificar si hay más de dos caracteres después del punto
      if (decimalPart.length > 2) {
        // Si hay más de dos caracteres después del punto, truncarlos
        percentClean = `${integerPart}.${decimalPart.substring(0, 2)}`;
      }
    }
    // Le agregamos el % al final
    return `${percentClean} %`;
  }

  validateCost(cost: string) {
    // Validar si hay un cosoto
    if (!cost) return '';

    // Verificar si existen 15 caracteres
    if (cost.length === 15) {
      // Poner los dos últimos como decimal
      cost = cost.slice(0, 13) + '.' + cost.slice(13);
    } else if (cost.length <= 13) {
      // Agregar '00' al final con el punto
      cost += cost.includes('.') ? '00' : '.00';
    } else if (cost.length === 14) {
      // Convertir el ultimo número en decimal y agregarle un cero
      cost = cost.slice(0, 13) + '.' + cost.slice(13) + '0';
    }

    // Validar si existen números decimales en la cadena de texto
    if (cost.includes('.')) {
      // Dividir la cadena en parte entera y parte decimal
      const [integerPart, decimalPart] = cost.split('.');

      // Verificar si hay más de dos caracteres después del punto
      if (decimalPart.length > 2) {
        // Si hay más de dos caracteres después del punto, truncarlos
        cost = `${integerPart}.${decimalPart.substring(0, 2)}`;
      }
    }

    return cost;
  }

  handleOnlyNumbers(e: KeyboardEvent) {
    // Obtener el código de la tecla presionada
    const charCode = e.charCode;
    // Permitir solo números (códigos de tecla del 0 al 9)
    if (charCode < 48 || charCode > 57) e.preventDefault();
  }

  handleOnlyNumbersAndLetters(e: KeyboardEvent) {
    // Obtener el código de la tecla presionada
    const charCode = e.which || e.keyCode;
    // Convertir el código de tecla en el carácter correspondiente
    const charStr = String.fromCharCode(charCode);
    // Expresión regular que define el patrón permitido: letras y números
    const pattern = /^[a-zA-Z0-9]+$/;
    // Si el carácter no cumple con el patrón, prevenir su inserción en el campo de entrada
    if (!pattern.test(charStr)) e.preventDefault();
  }

  handleConfirmation(confitmation: boolean) {
    if (confitmation) {
      if (['create', 'edit'].includes(this.confrmationData.action)) this.edit();
      if (this.confrmationData.action === 'close') this.close();
    }
    this.confrmationData = {};
    this.dialogConfirmation = false;
  }

  msgCongitmation(action: 'create' | 'edit' | 'close') {
    if (action === 'create') {
      this.confrmationData = {
        title: 'Editar Cobranza',
        msg: `¿Estás seguro de que deseas crear el equipo: "${this.paramApi.equipo.tipoeqname}" con la serie Nro: "${this.paramApi.serienumero}"?`,
        btnAceptar: 'Crear',
        btnCancelar: 'Cancelar',
      };
    } else if (action === 'edit') {
      this.confrmationData = {
        title: 'Editar Cobranza',
        msg: `¿Estás seguro de que deseas editar el equipo: "${this.data.tipoeqname}" con la serie Nro: "${this.data.serienumero}"?`,
        btnAceptar: 'Editar',
        btnCancelar: 'Cancelar',
      };
    } else if (action === 'close') {
      this.confrmationData = {
        title: 'Confirmación',
        msg:
          'Al cerrar esta ventana toda la información editada se perderá ¿Está seguro que desea cerrar sin guardar?',
        btnAceptar: 'Aceptar',
        btnCancelar: 'Cancelar',
      };
    }
    this.confrmationData.action = action;
    this.dialogConfirmation = true;
  }

  handleEdit() {
    // Llamo las funciones change para que sanitice los datos del dato
    this.handlePercent();
    this.handleCost();
    const {
      serienumero,
      tipoubicaid,
      serieime,
      seriecant_activa,
      costounitario,
      costounitario_clp,
      costoflete_oc,
      nuevoprecio_unitario,
      nuevoprecio_unitariousd,
      factorimportacion,
    } = this.paramApi;

    const tipoeqid = this.paramApi.equipo
      ? this.paramApi.equipo.tipoeqid
      : this.data.tipoeqid
      ? this.data.tipoeqid
      : '';

    // Valido que los campos obigatorios tenga datos
    if (!serienumero) {
      this.$snotify.error('El campo Número Serie es obligatorio');
      return;
    }

    if (!tipoeqid) {
      this.$snotify.error('El campo Equipo es obligatorio');
      return;
    }

    if (!tipoubicaid) {
      this.$snotify.error('El Tipo Ubicacón es obligatorio');
      return;
    }

    // Validar que serienumero no tenga una longitud mayor a 50
    if (serienumero.lengt > 50) {
      this.$snotify.error(
        'El Número Serie solo se permite un máximo de 50 caracteres'
      );
      return;
    }

    // Validar que serieime no tenga una longitud mayor a 50
    if (serieime && serieime.length > 50) {
      this.$snotify.error(
        'El Serie IMEI solo se permite un máximo de 50 caracteres'
      );
      return;
    }

    // Validar que seriecant_activa no tenga un valor numerico mayor a 999999
    const seriecantActivaInt = Number(seriecant_activa);
    if (seriecantActivaInt > 999999) {
      this.$snotify.error(
        'El número máximo permitido en el campo Serie Cantidad Activas es 999999'
      );
      return;
    }

    // Validar los costos
    // Agrego los costos a un array para validarlos en un loop
    const costs = [
      costounitario,
      costounitario_clp,
      costoflete_oc,
      nuevoprecio_unitario,
      nuevoprecio_unitariousd,
    ];

    // Validar que todos los costos cumplan con el valor establecido
    for (const cost of costs) {
      if (cost.includes('.')) {
        const [integerPart, decimalPart] = cost.split('.');
        if (decimalPart.length > 2 || integerPart.length > 13) {
          this.$snotify.error(
            'En los campos de costo solo se permiten máximo 13 números enteros y 2 decimales ejemplo: 9999999999999.99'
          );
          return;
        }
      } else if (cost && cost.length > 15) {
        this.$snotify.error(
          'El número máximo permitido en los campos de costo es 9999999999999.99'
        );
        return;
      }
    }

    // Validar el campo de porcentaje
    if (factorimportacion.includes('.')) {
      const [integerPart, decimalPart] = factorimportacion.split('.');
      const decimalPartClean = (decimalPart || '')
        .replace(/\s+/g, '')
        .replace('%', '');
      if (decimalPartClean.length > 2 || integerPart.length > 13) {
        this.$snotify.error(
          'En el campo factor inportación solo se permiten máximo 13 números enteros y 2 decimales ejemplo: 9999999999999.99'
        );
        return;
      }
    } else if (factorimportacion && factorimportacion.length > 15) {
      this.$snotify.error(
        'El número máximo permitido en el campo factor inportación es 9999999999999.99'
      );
      return;
    }

    // Si todos los datos están correctos abro el modal de confirmación
    const action = this.isEdit ? 'edit' : 'create';
    this.msgCongitmation(action);
    this.dialogConfirmation = true;
  }

  handleClose() {
    this.msgCongitmation('close');
  }

  close(clean: boolean = false): void {
    this.$emit('cerrar', clean);
  }

  async getFilters() {
    try {
      this.loadingService.showLoading();
      const result = await fetchMS({ endpoint: 'get_filters_edit' });
      const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA, FILTERS } = result.data;
      if (Number(CODIGO_RESPUESTA) !== 1) {
        this.$snotify.error(MENSAJE_RESPUESTA);
        return;
      }
      this.filterApi = { ...FILTERS };
    } catch (error) {
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor intente más tarde'
      );
    } finally {
      this.loadingService.hideLoading();
    }
  }

  async handleChange() {
    if (
      !this.isEdit &&
      (this.paramApi.serienumero !== this.data.serienumero &&
        this.paramApi.equipo.tipoeqid !== this.data.tipoeqid)
    ) {
      await this.validateDevice();
    } else if (
      this.isEdit &&
      this.paramApi.serienumero &&
      (this.paramApi.tipoeqid || this.paramApi.equipo.tipoeqid)
    ) {
      await this.validateDevice();
    }
  }

  async edit() {
    this.paramApi.tipoeqid = this.paramApi.equipo
      ? this.paramApi.equipo.tipoeqid
      : this.data.tipoeqid
      ? this.data.tipoeqid
      : '';

    const body = {
      is_edit: this.isEdit,
      ...this.paramApi,
      activaciones: this.Activaciones_equipos,
      curr_data: {
        tipoeqid: this.data.tipoeqid || '',
        serienumero: this.data.serienumero || '',
      },
    };

    try {
      this.loadingService.showLoading();
      const result = await fetchMS({ endpoint: 'edit', body });
      const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA, MENSAJE_API } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);

      if (cod !== 1) {
        return this.$snotify.error(MENSAJE_RESPUESTA);
      }

      if (MENSAJE_API) {
        this.$snotify.warning(MENSAJE_RESPUESTA, { timeout: 10000 });
      } else {
        this.$snotify.success(MENSAJE_RESPUESTA);
      }
      this.close(true);
    } catch (error) {
      console.error(error instanceof Error && error.message);
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor reintente un poco más tarde',
        { timeout: 3500 }
      );
    } finally {
      this.loadingService.hideLoading();
    }
  }

  async getDropdowns() {
    try {
      this.loadingService.showLoading();
      const result = await fetchMS({ endpoint: 'get_serieactiva_valores' });
      const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA, FILTERS } = result.data;
      if (Number(CODIGO_RESPUESTA) !== 1) {
        this.$snotify.error(MENSAJE_RESPUESTA);
        return;
      }
      this.DROPDOWNS_SERIEACTIVA = result.data;
      console.log(this.DROPDOWNS_SERIEACTIVA);
    } catch (error) {
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor intente más tarde'
      );
    } finally {
      this.loadingService.hideLoading();
    }
  }

  async getEquiposActivacion() {
    const body = {
      serienumero: this.data.serienumero,
    };
    this.Activaciones_equipos = await fetchMS({
      endpoint: 'query_get_activaciones',
      body,
    });
    this.Activaciones_equipos = this.Activaciones_equipos.data;

    this.Activaciones_equipos['Fecha de Alta'] = this.Activaciones_equipos[
      'Fecha de Alta'
    ]
      ? moment(this.Activaciones_equipos['Fecha de Alta'])
      : '';
    this.Activaciones_equipos['Fecha de Instalación'] = this
      .Activaciones_equipos['Fecha de Instalación']
      ? moment(this.Activaciones_equipos['Fecha de Instalación'])
      : '';
    this.Activaciones_equipos['Fecha de Baja'] = this.Activaciones_equipos[
      'Fecha de Baja'
    ]
      ? moment(this.Activaciones_equipos['Fecha de Baja'])
      : '';
    this.Activaciones_equipos['Fecha Plataforma'] = this.Activaciones_equipos[
      'Fecha Plataforma'
    ]
      ? moment(this.Activaciones_equipos['Fecha Plataforma'])
      : '';

    this.Activaciones_equipos['Flag INET OK'] = this.convertirSiNoABooleano(
      this.Activaciones_equipos['Flag INET OK']
    );
    this.Activaciones_equipos[
      'Activación Finalizada'
    ] = this.convertirSiNoABooleano(
      this.Activaciones_equipos['Activación Finalizada']
    );
    this.Activaciones_equipos['Flag CRM OK'] = this.convertirSiNoABooleano(
      this.Activaciones_equipos['Flag CRM OK']
    );
    this.Activaciones_equipos['Desinstalado'] = this.convertirSiNoABooleano(
      this.Activaciones_equipos['Desinstalado']
    );
    this.Activaciones_equipos['Es Arriendo'] = this.convertirSiNoABooleano(
      this.Activaciones_equipos['Es Arriendo']
    );
  }

  convertirSiNoABooleano(valor: any) {
    return valor === 'SÍ';
  }

  async validateDevice() {
    const tipoeqid = this.paramApi.equipo
      ? this.paramApi.equipo.tipoeqid
      : this.data.tipoeqid
      ? this.data.tipoeqid
      : '';

    const body = {
      serienumero: this.paramApi.serienumero,
      tipoeqid,
    };

    try {
      this.loadingService.showLoading();
      const result = await fetchMS({ endpoint: 'validate_device', body });
      const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);

      if (cod !== 1) {
        this.btnDisabled = true;
        return this.$snotify.error(MENSAJE_RESPUESTA);
      }
      this.btnDisabled = false;
    } catch (error) {
      console.error(error instanceof Error && error.message);
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor reintente un poco más tarde',
        { timeout: 3500 }
      );
    } finally {
      this.loadingService.hideLoading();
    }
  }
}
